export default __webpack_public_path__ + "static/media/Gilroy-Semibold.41fa36c3.ttf";